import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { CreditCardsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createCreditCard = (data): any => action(types.CREATE_CREDIT_CARD_REQUESTED, data);

export const createCreditCardToken = (data): any => action(types.CREATE_CREDIT_CARD_TOKEN_REQUESTED, data);

export const updateCreditCard = (data): any => action(types.UPDATE_CREDIT_CARD_REQUESTED, data);

export const deleteCreditCard = (creditCardId): any => action(types.UPDATE_CREDIT_CARD_REQUESTED, creditCardId);

export const getCreditCard = (creditCardId): any => action(types.GET_CREDIT_CARD_REQUESTED, creditCardId);

export const getAllCreditCards = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_CREDIT_CARDS_REQUESTED, { pagination, compile });

export const selectCreditCard = (creditCardId): any => action(types.SELECT_CREDIT_CARD_REQUESTED, {
  currentCreditCardId: creditCardId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createCreditCardPending: (): any => action(types.CREATE_CREDIT_CARD_PENDING),
  createCreditCardSuccess: (response): any => action(types.CREATE_CREDIT_CARD_SUCCESS, {
    creditCardsById: response.entities.creditCards,
    currentCreditCardId: response.result,
  }),
  createCreditCardFailed: (error): any => action(types.CREATE_CREDIT_CARD_FAIL, { backendErrors: error }),
  createCreditCardTokenPending: (): any => action(types.CREATE_CREDIT_CARD_TOKEN_PENDING),
  createCreditCardTokenSuccess: (response): any => {
    const { creditCardTokens } = response.entities;

    return action(types.CREATE_CREDIT_CARD_TOKEN_SUCCESS, {
      creditCardToken: creditCardTokens[response.result].cardToken,
    });
  },
  createCreditCardTokenFailed: (error): any => action(types.CREATE_CREDIT_CARD_TOKEN_FAIL, { backendErrors: error }),
  updateCreditCardPending: (payload): any => action(types.UPDATE_CREDIT_CARD_PENDING, payload),
  updateCreditCardSuccess: (response): any => action(types.UPDATE_CREDIT_CARD_SUCCESS, {
    creditCardsById: response.entities.creditCards,
    currentCreditCardId: response.result,
  }),
  updateCreditCardFailed: (error): any => action(types.UPDATE_CREDIT_CARD_FAIL, { backendErrors: error }),
  deleteCreditCardPending: (): any => action(types.UPDATE_CREDIT_CARD_PENDING, {}),
  deleteCreditCardSuccess: (response, userId): any => {
    localStorage.set(userId, { currentCreditCardId: null });

    return action(types.DELETE_CREDIT_CARD_SUCCESS, {
      currentCreditCardId: response,
    });
  },
  deleteCreditCardFailed: (error): any => action(types.UPDATE_CREDIT_CARD_FAIL, { backendErrors: error }),
  getCreditCardPending: (): any => action(types.GET_CREDIT_CARD_PENDING, {}),
  getCreditCardSuccess: (response): any => action(types.GET_CREDIT_CARD_SUCCESS, {
    creditCardsById: response.entities.creditCards,
    currentCreditCardId: response.result,
  }),
  getCreditCardFailed: (error): any => action(types.GET_CREDIT_CARD_FAIL, { backendErrors: error }),
  getAllCreditCardsPending: (pagination): any => action(types.GET_ALL_CREDIT_CARDS_PENDING, { pagination }),
  getAllCreditCardsSuccess: (response, meta): any => action(types.GET_ALL_CREDIT_CARDS_SUCCESS, {
    creditCardsById: response.entities.creditCards,
    creditCardIds: response.result,
    meta,
  }),
  getAllCreditCardsFailed: (error): any => action(types.GET_ALL_CREDIT_CARDS_FAIL, { backendErrors: error }),
};

export default null;
